import { gql } from "@apollo/client";

export const APP_DOCUMENT_QF = gql`
  fragment AppDocumentFields on AppDocument {
    id
    name
    category
    fileUrl
    filename
    extension
    __typename
  }
`;

export const HOUSING_LOTTERY_MANAGER_QF = gql`
  fragment HousingLotteryManagerFields on HousingLottery {
    id
    isExpired
    applicantAccommodations
    contactEmail
    contactName
    contactPhone
    details
    endDate
    infoSession1Datetime
    infoSession2Datetime
    infoSessionDetails
    infoSessionUrl
    ownContactInfo
    notifyPropertyContact
    startDate
    url
    waitlistStatus
    unitTypes
    allowedUnitTypes
    isAllUnits
    isActive
    isPublishedActive
    isUnitsChanged
    isDatesChanged
    propertyContacts {
      id
      name
      phone
      email
    }
    documents {
      ...AppDocumentFields
    }
    __typename
  }
  ${APP_DOCUMENT_QF}
`;

export const HOUSING_FCFS_AVAILABILITY_MANAGER_QF = gql`
  fragment HousingVacancyManagerFields on HousingVacancy {
    id
    publishedActive
    expiryDays
    transitionDate
    details
    notifyPropertyContact
    isExpired
    isCurrent
    isEmpty
    isActive
    isUnitsChanged
    transitionToSw
    transitioned
    transitionedToSw
    propertyContacts {
      id
      name
      phone
      email
    }
    unitGroups {
      id
      fcfsUnitCount
      unitType
      bathroomCount
    }
    availableUnitGroups {
      id
      fcfsUnitCount
    }
    documents {
      ...AppDocumentFields
    }
    __typename
  }
  ${APP_DOCUMENT_QF}
`;

export const HOUSING_SHORT_WAITLIST_AVAILABILITY_MANAGER_QF = gql`
  fragment HousingShortWaitlistManagerFields on HousingShortWaitlist {
    expiryDays
    id
    isActive
    isCurrent
    isEmpty
    isExpired
    isUnitsChanged
    notifyPropertyContact
    publishedActive
    transitionDate
    transitioned
    propertyContacts {
      id
      name
      phone
      email
    }
    unitGroups {
      id
      fcfsUnitCount
      shortWaitlist
      unitType
      bathroomCount
    }
    availableUnitGroups {
      id
      fcfsUnitCount
      shortWaitlist
    }
    __typename
  }
`;
